import "./App.css";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SurveyLandingPage from "./pages/SurveyLandingPage";  // ✅ Correct Import
import LandingPage from "./pages/LandingPage";  // ✅ Ensure this file exists

function App() {
  return (
    <Router>
      <Routes>
        {/* ✅ Main survey landing page */}
        <Route path="/" element={<SurveyLandingPage />} />

        {/* ✅ Dynamic landing page routes based on keyword and tier */}
        <Route path="/:keyword" element={<LandingPage />} />
        <Route path="/:keyword/:tier" element={<LandingPage />} />
      </Routes>
    </Router>
  );
}

export default App;
